import { useContext } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import { encryptURL, decryptURL } from 'utils/functions';
import { GridContext } from 'contexts/GridContext';
import { DropsContext } from 'contexts/DropsContext';
import { EnderecoContext } from 'contexts/EnderecoContext';
import { RelatoriosContext } from 'contexts/RelatoriosContext';
import { useModal } from 'components/Modals';
import ResumoModal from 'components/Modals/ResumoModal';
import DeleteModal from 'components/Modals/DeleteModal';
import Container from 'components/Container';
import Header from 'components/Header';
import Card from 'components/Card';
import Grid from 'components/Grid';
import Filter from './filter';

const Enderecos = () => {
  const rotina = 'Ceendereco';
  const titulo = 'Endereços de Estoque';
  const { hash } = useParams();
  const decrypt = decryptURL(hash);
  const navigate = useNavigate();
  const { openModal, closeModal } = useModal();
  const { drops } = useContext(DropsContext);
  const { getURLRelatorio } = useContext(RelatoriosContext);
  const { deleteGrid, exportPdf, exportXls } = useContext(GridContext);
  const { endereco, getEndereco, getLoading } = useContext(EnderecoContext);
  const defaultValues = { ...endereco?.filter, celocal_id: [decrypt.id] };
  const { control, getValues, reset } = useForm({ defaultValues });

  const loadGrid = (props) => {
    if (props?.replace) {
      reset();
    }
    getEndereco({ ...props, rotina, filter: getValues() });
  };

  const handleGerar = (values) =>
    navigate(`/app/Locais/Enderecos/Gerar/${encryptURL(values)}`);

  const options = [
    {
      name: 'Adicionar',
      icon: 'add',
      action: () => handleGerar({ celocal_id: decrypt?.id }),
    },
    {
      name: 'Exportar PDF',
      icon: 'file_download',
      action: () =>
        exportPdf({ rotina, filter: getValues(), order: endereco?.order }),
    },
    {
      name: 'Exportar XLS',
      icon: 'file_download',
      action: () =>
        exportXls({ rotina, filter: getValues(), order: endereco?.order }),
    },
    {
      name: 'Resumo',
      icon: 'summarize',
      action: () =>
        openModal(
          <ResumoModal
            colunas={endereco?.colunas}
            onSubmit={(group) =>
              navigate('/app/Resumo', {
                state: { rotina, group, filter: getValues() },
              })
            }
          />
        ),
    },
    {
      name: 'Etiqueta',
      icon: 'print',
      action: (a) =>
        getURLRelatorio({
          data: {
            codigo: 'ETQEND',
            ids: a?.map((row) => row?.id),
            impressora_id: 2,
          },
        }),
    },
    {
      name: 'Transferência',
      icon: 'sync',
      action: () => navigate('/app/Locais/Enderecos/Transferencia'),
    },
  ];

  const rowOptions = [
    {
      name: 'Editar',
      icon: 'edit',
      action: ({ row }) => handleGerar(row),
    },
    {
      name: 'Deletar',
      icon: 'delete',
      action: ({ row }) =>
        openModal(
          <DeleteModal
            onSubmit={() =>
              deleteGrid({
                params: { rotina, id: row?.id },
                cb: () => {
                  loadGrid();
                  closeModal();
                },
              })
            }
          />
        ),
    },
    {
      name: 'Ver Estoque',
      icon: 'map',
      menu: true,
      action: ({ row }) => {
        const params = {
          ceendereco_id: row?.id,
          celocal_id: decrypt?.id,
          filial_id: decrypt?.filial_id,
        };
        navigate(`/app/Estoque/${encryptURL(params)}`);
      },
    },
    {
      name: 'Etiqueta',
      icon: 'print',
      menu: true,
      action: ({ row }) =>
        getURLRelatorio({
          data: {
            codigo: 'ETQEND',
            ids: [row?.id],
            impressora_id: 2,
          },
        }),
    },
  ];

  return (
    <Container>
      <Header
        rotina={rotina}
        titulo={titulo}
        subtitulo={`${decrypt?.local || ''} - ${decrypt?.descricao || ''}`}
        colunas={endereco?.colunas}
      />
      <Card>
        <Grid
          grid={endereco}
          options={options}
          rowOptions={rowOptions}
          control={control}
          checkboxSelection
          loading={getLoading}
          loadGrid={loadGrid}
          activeFilter={(getActiveFilter) => getActiveFilter(getValues())}
          FilterComponent={
            <Filter grid={endereco} control={control} drops={drops} />
          }
        />
      </Card>
    </Container>
  );
};

export default Enderecos;
